jQuery(function($) {
    let foxPostDialog = $('#foxpost_woo_parcel_dialog');
    foxPostDialog.addClass('show');
    checkSelectedShippingMethod($);
});

/**
 * Check the selected shipping method, and hide/show the foxpost element by the checked shipping method
 */
function checkSelectedShippingMethod($) {
    $('body').on('updated_checkout', function() {
         
        let defaultSelectedShipping = $('input[type="radio"]:checked');

        if (defaultSelectedShipping.val().indexOf('home_delivery') !== -1) {
            setTimeout(() => {
                hideFoxPostElements()
            }, 200);
        }

        $('input[type="radio"]').change(function() {
           if ($(this).val().indexOf('home_delivery') !== -1) {

            setTimeout(() => {
                hideFoxPostElements()
            }, 200);
           } else {
               setTimeout(() => {
                   showFoxPostElements();
               }, 200);
           }
        });
    });
}

/**
 * Show the post fox default elements
 */
function showFoxPostElements() {
   const orderTotal = jQuery('.order-total');
   orderTotal.siblings('p').show();
   orderTotal.siblings().siblings('select').show();
   orderTotal.siblings().siblings().siblings('a').show();
}

/**
 * Hide the fox post default elements
 */
function hideFoxPostElements() {
    const orderTotal = jQuery('.order-total');
    orderTotal.siblings('p').hide();
    orderTotal.siblings().siblings('select').hide();
    orderTotal.siblings().siblings().siblings('a').hide();
}
